import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined';
import AlternateEmailOutlinedIcon from '@mui/icons-material/AlternateEmailOutlined';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import EventBusyOutlinedIcon from '@mui/icons-material/EventBusyOutlined';
import AppInformation from './AppInformation';
import GeneralSettings from './GeneralSettings';
import LanguageSetting from './LanguageSetting';
import SMTPSettings from './SMTPSettings';
import SmsSettings from './SmsSettings';
import CancellationReasons from './CancellationReasons';
import { c2PillTabsSx } from '../components/Table/C2UserTable';

const TABS = [
  { key: 'app', label: 'Empresa y app', icon: BusinessOutlinedIcon, Component: AppInformation },
  { key: 'general', label: 'Operación', icon: TuneOutlinedIcon, Component: GeneralSettings },
  { key: 'language', label: 'Idiomas', icon: TranslateOutlinedIcon, Component: LanguageSetting },
  { key: 'smtp', label: 'Correo (SMTP)', icon: AlternateEmailOutlinedIcon, Component: SMTPSettings },
  { key: 'sms', label: 'SMS / OTP', icon: SmsOutlinedIcon, Component: SmsSettings },
  { key: 'cancel', label: 'Motivos de cancelación', icon: EventBusyOutlinedIcon, Component: CancellationReasons },
];

export default function Settings() {
  const [value, setValue] = useState(0);
  const [visited, setVisited] = useState({ 0: true });
  const [dirtyTabs, setDirtyTabs] = useState({});

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setVisited((v) => ({ ...v, [newValue]: true }));
  };

  const markDirty = useCallback((index, dirty) => {
    setDirtyTabs((d) => (!!d[index] === dirty ? d : { ...d, [index]: dirty }));
  }, []);
  const dirtyHandlers = useMemo(() => TABS.map((_, index) => (dirty) => markDirty(index, dirty)), [markDirty]);
  const anyDirty = Object.values(dirtyTabs).some(Boolean);

  useEffect(() => {
    if (!anyDirty) return undefined;
    const warn = (e) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [anyDirty]);

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        aria-label="Secciones de configuración"
        sx={{ ...c2PillTabsSx, mb: 2.5 }}
      >
        {TABS.map((tab, index) => {
          const Icon = tab.icon;
          return (
            <Tab
              key={tab.key}
              id={`settings-tab-${index}`}
              aria-controls={`settings-tabpanel-${index}`}
              icon={<Icon sx={{ fontSize: 20 }} />}
              iconPosition="start"
              label={
                <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
                  {tab.label}
                  {dirtyTabs[index] ? (
                    <Box component="span" title="Cambios sin guardar" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#F5B301' }} />
                  ) : null}
                </Box>
              }
            />
          );
        })}
      </Tabs>
      {TABS.map((tab, index) => {
        const Component = tab.Component;
        return (
          <div
            key={tab.key}
            role="tabpanel"
            hidden={value !== index}
            id={`settings-tabpanel-${index}`}
            aria-labelledby={`settings-tab-${index}`}
          >
            {visited[index] ? <Component onDirtyChange={dirtyHandlers[index]} /> : null}
          </div>
        );
      })}
    </Box>
  );
}
